/**
 * if modified please pass the update to tests/singleWorker/patientFlow/types.ts
 */
export enum EPatientLinkedEntity {
  GP_PRACTICE = "gpPractice",
  GP = "gp",
  ORTHO_PRACTICE = "orthoPractice",
  ORTHO = "ortho",
  TC_COORDINATOR = "treatmentCoordinator",
}

export type TPatientLinkApiConfig = {
  linkPath: string;
  listPath: string;
  payloadKey: string;
  typeOfEntity: "practice" | "staff";
};

export const API_CONFIG = {
  [EPatientLinkedEntity.GP_PRACTICE]: {
    linkPath: "link_gp_practice",
    listPath: "list_of_gp_practices",
    payloadKey: "practice_id",
    typeOfEntity: "practice",
  },
  [EPatientLinkedEntity.GP]: {
    linkPath: "link_gp",
    listPath: "list_of_gps",
    payloadKey: "gp_linked",
    typeOfEntity: "staff",
  },
  [EPatientLinkedEntity.ORTHO_PRACTICE]: {
    linkPath: "link_ortho_practice",
    listPath: "list_of_ortho_practices",
    payloadKey: "practice_id",
    typeOfEntity: "practice",
  },
  [EPatientLinkedEntity.ORTHO]: {
    linkPath: "link_ortho",
    listPath: "list_of_orthodontists",
    payloadKey: "ortho_linked",
    typeOfEntity: "staff",
  },
  [EPatientLinkedEntity.TC_COORDINATOR]: {
    linkPath: "link_treatment_coordinator",
    listPath: "list_of_treatment_coordinators",
    payloadKey: "tc_linked",
    typeOfEntity: "staff",
  },
} as const satisfies Record<EPatientLinkedEntity, TPatientLinkApiConfig>;

export type TProviderKindKey = keyof typeof API_CONFIG;
